export enum TaskChoiceIdx {
  TWO_SUM = 0,
  VALID_PALINDROME = 1,
  REVERSE_LINKED_LIST = 2,
  FREQUENT_ELEMENTS = 3,
  MOST_WATER = 4,
  DEAR_DIARY = 5,
  WAY_WITH_WORDS = 6,
  POMODORO = 7,
  RAIN_CHECK = 8,
  PUSH_THE_ENVELOPE = 9,
  BIG_MAC = 10,
  CHARACTER_CREATOR = 11,
  SPACE_RACE = 12,
  CALCULATOR = 13,
  PRICE_IS_RIGHT = 14,
  HEAD_COUNT = 15,
  RETAIL_THERAPY = 16,
  QUERY_STRING_QUEST = 17,
  SHARING_IS_CARING = 18,
  HELLO_WORLD = 19,
  HOT_TAKES = 20,
  MOVIE_LIST = 21,
  TOP_SECRET = 22,
  ADD_TO_CART = 23,
  BOOKWORM = 24,
  BIG_DATA = 25,
  CLOUDCEPTION = 26,
  CORS_CONTROL = 27,
  TICKET_TO_RIDE = 28,
  MOOD_MATCHER = 29,
}
